var _path, _g, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 140,
    viewBox: "0 0 420 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 50 L210 10 L410 50 L410 130 L10 130 Z",
    stroke: "#0ddcf4",
    strokeWidth: 4,
    fill: "none",
    rx: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 40 L45 20 L65 40 L65 65 L25 65 Z",
    fill: "#0ddcf4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 40 L45 20 L65 40",
    stroke: "#282c34",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 45,
    width: 14,
    height: 20,
    fill: "#282c34"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 100,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    fill: "#282c34"
  }, "\n    house\n    ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#0ddcf4"
  }, "wow"), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 24
  }, ".ru"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ea8efcf307d583ddc69269741d7bf842.svg";
export { ForwardRef as ReactComponent };